/*
LOCAL DEMO MODE - development only.

Switched on by REACT_APP_DEMO_LOCAL in .env, which is never set in a deployed
build. It points the app at the local emulators so the whole app, including the
export features, can be run and shown without touching a real project.
*/
export const isLocalDemo = process.env.REACT_APP_DEMO_LOCAL === 'true';

export const firestoreEmulatorHost = '127.0.0.1:8086';
export const functionsEmulatorPort = 5001;
export const functionsEmulatorUrl = 'http://127.0.0.1:' + functionsEmulatorPort;

export const getEmulatorFunctionUrl = (projectId, region, functionName) => {
  return [functionsEmulatorUrl, projectId, region, functionName].join('/');
};
